module.exports = __webpack_public_path__ + "media/St 4-thermostat-question.061b38cc.wav";